import React from "react";
import BuildIcon from "../icons/BuildIcon.js";

export default class AjaxAgenda extends React.Component {
  constructor(props) {
    super(props);

    this.resultsRef = React.createRef();
    this.sessionHeight = window.sessionStorage.getItem(window.nodeId);
    
    this.state = {
      ajaxAgenda: {}
    }

  this.resizeObserver = new ResizeObserver((entries) => {
    const height = this.resultsRef.current.clientHeight;
    window.sessionStorage.setItem(window.nodeId, `${height}`);
    this.resultsRef.current.parentElement.style.minHeight = `${height || this.sessionHeight}px`;
  });
}

  handlePostFetch() {
    document.querySelectorAll('.paper-abstract-toggle').forEach(function(item) {
      item.addEventListener('click', function() {
        let toggle = item.nextElementSibling;
        item.classList.toggle('open');
        if (!toggle.classList.contains('active')) {
          toggle.style.height = 'auto';
        }
        else {
          toggle.style.height = '0px';
        }
        toggle.classList.toggle('active');
      });
    });

    if (!this.state.ajaxAgenda || this.state.ajaxAgenda.length == 0) {
      const notices = document.querySelectorAll('.page-header__intro-notice');
      let agendaPending = document.createElement('span');

      agendaPending.innerHTML = 'Agenda pending.';
      agendaPending.className = 'agenda-pending-notice';
      notices[notices.length - 1].append(agendaPending);
    }
  }

  componentDidMount() {
    // setting a min-height to resolve an incorrect scroll location when hitting the back button - Jonathan 9.2022
    this.resizeObserver.observe(this.resultsRef.current);

    // for Local development in Pattern Lab
    if (window.mockData) {
      window.setTimeout(() => {
        this.setState({ ajaxAgenda: window.mockData.items }, this.handlePostFetch);
      }, 1000);
    } else {
      fetch('/api/conference/' + window.nodeId + '/agenda')
        .then(response => {
          return response.json();
        })
        .then(json => {
          this.setState({ ajaxAgenda: json.items, showParticipants: json.show_participants }, this.handlePostFetch)
        })
        .catch(error => {
          console.log('An error occured while fetching conference agenda data');
        });
    }
  }

  render() {
    let finalMarkup = ['<div class="agenda">'];

    if (this.state.ajaxAgenda && this.state.ajaxAgenda.length > 0) {
      for (const item of this.state.ajaxAgenda) {
        // console.log(item);
        // link to schedule editor removed as per discussion w Carl & Rob 2021-05-15
        // day headers are hashrefs of info with the weekday and date
        if (item.is_hashref) {
          finalMarkup.push('<div class="agenda-day"><h3 class="agenda-day__title">' + item.DAY + ', ' + item.MDD + '</h3></div>');
        }
        else if (item.paper) {
          let videoUrl;
          let markup = '<div class="agenda-entry">'
            + '<div class="agenda-entry__time">' + item.schedule_time_display + (item.record && item.record.room ? '<div class="agenda-entry__room">' + item.record.room + '</div>' : '') + '</div>'
            + '<div class="agenda-entry__info rich-text">'
            + '<div class="entry-title-wrapper">';

          if (item.paper.isreceived == 1) {
            // conference_program_paper_url is either the remote_url or a URL to the PDF hosted on backend
            markup += '<a class="paper-title" href="' + item.paper.conference_program_paper_url + '">' + item.paper.record.title + '</a>';
          }
          else {
            markup += '<span class="paper-title">' + item.paper.record.title + '</span>';
          }

          if (item.paper.slides_url) {
            markup += '<span class="slides">(<a href="' + item.paper.slides_url + '" target="_blank">slides</a>)</span>';
          }

          if (item.record && item.record.txt && item.record.txt.length > 0) {
            markup += '<span class="schedule-item-title schedule-item-' + item.record.class + '"> ' + item.record.txt + '</span>';
          }

          markup += '</div>';

          if (item.paper.author_with_objs_array.length > 0) {
            markup += '<div class="paper-authors">';
            for (const author of item.paper.author_with_objs_array) {
              // flagged authors are supposed to be bold to indicate that they are the presenter
              markup += '<div>';
              if (author.name) {
                // name explicitly set for authors occasionally with internal html
                markup += '<span class="author-name' + (author.flagged == 1 ? ' flagged-author' : '') +'">';
                if (window.summaryMode && author.obj && author.obj.show_profile != 0 && author.obj.url && author.obj.url.length > 0) {
                  markup += '<a href="' + author.obj.url + '">';
                }
                markup += author.name;
                if (window.summaryMode && author.obj && author.obj.show_profile != 0 && author.obj.url && author.obj.url.length > 0) {
                  markup += '</a>';
                }
                markup += '</span>';
              }
              if (author.obj && author.obj.univaffil_and_nber) {
                markup += ', <span class="affiliation">' + author.obj.univaffil_and_nber + '</span>';
              }
              markup += '</div>';
            }
            markup += '</div>';
          }

          for (const paper of window.confPapers) {
            if (paper.id == item.record.paper) {
              videoUrl = paper.lecture_path;
            }
          }

          if (item.paper.abstract_clean_html) {
            markup += '<div class="paper-abstract">';
            markup += '<span class="paper-abstract-toggle"><span>View abstract</span>' + BuildIcon('arrow-down') + '</span>';
            markup += '<div class="paper-abstract-body">' + item.paper.abstract_clean_html + '</div>';
            markup += '</div>';
          }

          if (item.paper.slides_url || item.paper.conference_program_paper_url || item.paper.executive_summary_url || videoUrl) {
            markup += '<div class="paper-links">';
            if (item.paper.conf_presented_pnum) {
              markup += '<div class="working-paper">This paper was distributed as <a href="https://www.nber.org/papers/' + item.paper.conf_presented_pnum + '" target="_blank">Working Paper ' + item.paper.conf_presented_pnum.substr(1) + '</a>, where an updated version may be available.</div>';
            }
            if (item.paper.slides_url) {
              markup += '<span class="slides"><a href="' + item.paper.slides_url + '" target="_blank">';
              markup += BuildIcon('slides');
              markup += '</a><a href="' + item.paper.slides_url + '" target="_blank">Slides</a></span>';
            }
            if (item.paper.executive_summary_url) {
              markup += '<span class="executive-summary"><a href="' + item.paper.executive_summary_url + '" target="_blank">';
              markup += BuildIcon('exec-summary');
              markup += '</a><a href="' + item.paper.executive_summary_url + '" target="_blank">Executive Summary</a></span>';
            }
            if (videoUrl) {
              markup += '<span class="video"><a href="' + videoUrl + '" target="_blank">';
              markup += BuildIcon('video');
              markup += '</a><a href="' + videoUrl + '" target="_blank">Video</a></span>';
            }
            markup += '</div>';
          }

          if (item.paper.discussant_struct.length > 0) {
            markup += '<div class="paper-discussants"><div>' + item.paper.discussants_label + ':</div>';
            for (const discussant of item.paper.discussant_struct) {
              markup += '<div>';
              if (discussant.user) {
                markup += '<span class="discussant-name">';
                if (window.summaryMode && discussant.user.show_profile == 1 && discussant.user.url && discussant.user.url.length > 0) {
                  markup += '<a href="' + discussant.user.url + '">';
                }
                markup += discussant.user.fullname;
                if (window.summaryMode && discussant.user.show_profile == 1 && discussant.user.url && discussant.user.url.length > 0) {
                  markup += '</a>';
                }
                markup += '</span>';
                if (discussant.user.univaffil_and_nber) {
                  markup += ', <span class="affiliation">' + discussant.user.univaffil_and_nber + '</span>';
                }
                if (discussant.slides_url) {
                  markup += '<span class="slides">(<a href="' + discussant.slides_url + '" target="_blank">slides</a>)</span>';
                }
              }
              else {
                markup += discussant.discussant_user.replaceAll('_', ' ') + '</span>';
              }
              markup += '</div>';
            }
            markup += '</div>';
          }

          markup += '</div></div>';
          finalMarkup.push(markup);
        }
        else if (item.record) {
          finalMarkup.push('<div class="agenda-entry contains-' + item.record.class + '"><div class="agenda-entry__time">' + item.schedule_time_display + '</div>'
            + '<div class="agenda-entry__info rich-text"><div class="entry-title-wrapper"><span class="schedule-item-title schedule-item-' + item.record.class + '">' + (item.record.txt ? item.record.txt : '') + '</span></div>'
            + '</div></div>');
        }
      }
    }

    finalMarkup.push('</div>');

    if (this.state.showParticipants == 1) {
      finalMarkup.push('<div class="participants">');

      if (segmentParticipants && isHybrid == 1) {
        finalMarkup.push('<section class="promo-grid promo-grid--2-up promo-grid--centered"><h2 class="promo-grid__title">In-Person Participants</h2><div class="promo-grid__promos">');
        for (const participant of inperson_participants) {
          finalMarkup.push('<div class="name-promo">'
            + (participant.url ? '<a href="' + participant.url + '">' : '')
            + '<span class="name-promo__name">' + participant.name + '</span>'
            + (participant.url ? '</a>' : '')
            + (participant.affiliation ? ', <span class="name-promo__title">' + participant.affiliation + '</span>' : '')
            + '</div>');
        }
        finalMarkup.push('</div></section>');

        finalMarkup.push('<section class="promo-grid promo-grid--2-up promo-grid--centered"><h2 class="promo-grid__title">Remote Participants</h2><div class="promo-grid__promos">');
        for (const participant of remote_participants) {
          finalMarkup.push('<div class="name-promo">'
            + (participant.url ? '<a href="' + participant.url + '">' : '')
            + '<span class="name-promo__name">' + participant.name + '</span>'
            + (participant.url ? '</a>' : '')
            + (participant.affiliation ? ', <span class="name-promo__title">' + participant.affiliation + '</span>' : '')
            + '</div>');
        }
        finalMarkup.push('</div></div></section>');
      }
      else {
        if (participants.length > 0) {
          finalMarkup.push('<section class="promo-grid promo-grid--2-up promo-grid--centered"><h2 class="promo-grid__title">Participants</h2><div class="promo-grid__promos">');
          for (const participant of participants) {
            finalMarkup.push('<div class="name-promo">'
              + (participant.url ? '<a href="' + participant.url + '">' : '')
              + '<span class="name-promo__name">' + participant.name + '</span>'
              + (participant.url ? '</a>' : '')
              + (participant.affiliation ? ', <span class="name-promo__title">' + participant.affiliation + '</span>' : '')
              + '</div>');
          }
          finalMarkup.push('</div></section>');
        }
      }

      finalMarkup.push('</div>');
    }

    return (
      <div ref={this.resultsRef} dangerouslySetInnerHTML={{ __html: finalMarkup.join('') }}></div>
    );
  }
}
